import { Grid, GridItem, Link, styled } from '@nilohealth/core-ui'

export const DashboardLayoutContainer = styled('div', {
  position: 'relative',
  display: 'flex',
  width: '100%',
  flex: 1,
  marginBottom: '$xxlarge',
  '> div': { alignItems: 'flex-start' },
})

export const DashboardLayoutBackground = styled('div', {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '$huge',
  backgroundColor: '$neutralHighPure',
})

export const DashboardCard = styled('div', {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  borderRadius: '$medium',
  border: '1px solid $neutralHighLight',
  padding: '$xxsmall $xxxsmall',
  width: '100%',
  backgroundColor: '$neutralHighPure',
})

export const DashboardGroupCard = styled('div', {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  borderRadius: '$medium',
  border: '1px solid $neutralHighLight',
  padding: '$xxxsmall',
  width: '100%',
  backgroundColor: '$neutralHighPure',
})

export const DashboardGroupCardLink = styled(Link, {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: '$quarck',
  width: 'fit-content',
  color: '$neutralLowDark !important',
  border: 'none !important',
  '&:hover': {
    color: '$primaryMedium !important',
    svg: { color: '$primaryMedium !important' },
  },
})

export const DashboardCardContent = styled('div', {
  display: 'grid',
  justifyContent: 'space-between',
  width: '100%',
  '@sm': {
    gridTemplateColumns: 'repeat(auto-fill, $huge)',
    rowGap: '$xxxsmall',
  },
  '@md': {
    gridTemplateColumns: 'repeat(auto-fill, $giant)',
    rowGap: '$xxxsmall',
  },
  '@lg': {
    gridTemplateColumns: 'repeat(auto-fill, $giant)',
    rowGap: '$xxxsmall',
  },
})

export const CategoryIconWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  size: '$xxxsmall',
  borderRadius: '$circular',
  '&:hover': { cursor: 'help', },
  svg: {
    size: '$micro',
    minSize: '$micro',
  }
})

export const DashboardBigNumbers = styled(Grid, {
  justifyContent: 'space-between',
  columnGap: '$xxsmall',
  rowGap: '$xxsmall',
  width: '100%',
  '@sm': { gridTemplateColumns: '1fr 1fr 1fr 1fr' },
  '@md': { gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr' },
  '@lg': { gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr' },
})

export const DashboardContentFilters = styled(GridItem, {
  position: 'sticky',
  top: 0,
  backgroundColor: '$neutralHighLight',
  padding: '$nano $none',
  marginBottom: '$xxxsmall',
  marginLeft: 'auto',
  width: '100%',
  zIndex: '$zIndex200',
})
